import type { ReactNode } from 'react';
import { useT } from '../../lib/i18n.tsx';
import { Table, TableScroll, Td, Th } from '../ui/table.tsx';

/**
 * Every chart is accompanied by its data as a real table (WCAG: a non-visual alternative). It sits
 * in a collapsed disclosure so it does not crowd the page, and screen readers can open it.
 */
export function ChartTable({
  title,
  columns,
  rows,
}: {
  title: string;
  columns: readonly string[];
  rows: readonly (readonly ReactNode[])[];
}) {
  const t = useT();
  return (
    <details className="mt-2 text-sm">
      <summary className="cursor-pointer rounded-sm text-muted-foreground hover:text-foreground">
        {t.common.showTable}
      </summary>
      <TableScroll className="mt-2 max-h-64 overflow-y-auto">
        <Table>
          <caption className="sr-only">{t.common.chartTable(title)}</caption>
          <thead>
            <tr>
              {columns.map((column, index) => (
                <Th key={column} scope="col" className={index > 0 ? 'text-right' : ''}>
                  {column}
                </Th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((row, rowIndex) => (
              <tr key={rowIndex}>
                {row.map((cell, index) => (
                  <Td key={index} className={index > 0 ? 'text-right tabular-nums' : ''}>
                    {cell}
                  </Td>
                ))}
              </tr>
            ))}
          </tbody>
        </Table>
      </TableScroll>
    </details>
  );
}
